import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;
const environment = process.env.REACT_APP_ENVIRONMENT;

console.log("API URL:", API_URL);
console.log("Environment:", environment);

// Axios instance
const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});



// ❗Leave response interceptor empty (success message handled elsewhere)
export default apiClient;